import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import ActivationHead from './ActivationHead';
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import swal from 'sweetalert';

import { getApiHeader } from 'utlis/commonfunctions';
import Loader from './loader';
import userEvent from '@testing-library/user-event';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { colors } from '@mui/material';


function YourMobileNumber({ nextStep, prevStep, commonSession, selectedPlanData, handleMobile, newMobile,setStep, iddCheck }) {

    var pre_selected_number_type = false;
    if(newMobile !==null){
        var pre_selected_number_type = 'new';
    }

    const [numberType, setNumberType] = useState(pre_selected_number_type);
    const [sendOtp, setSendOtp] = useState(false);
    const [verifyOtp, setVerifyOtp] = useState(false);
    const [providerStatus, setProviderStatus] = useState(false);
    const [provider, setProvider] = useState('');
    const [serviceType, setServiceType] = useState('');
    const [isMultiNumber, setIsMultiple] = useState(false);
    const [multiNumbers, setMultiNumbers] = useState([]);

    const [premiumNumbers, setPremiumNumber] = useState([]);
    const [showPremiumNumber, setShowPremiumNumber] = useState(false);

    const [mobileNumber, setMobileNumber] = useState(newMobile);
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState('')
    const [otpVerifySessionId, setOtpVerifySessionId] = useState('')
    const [existingNumber, setExistNumber] = useState("")
    const [mobileProviders, setMobileProviders] = useState([]);

    const [paymentStatus, setPaymentStatus] = useState(false);
    const [retailerType, setRetailerType] = useState("")
    const [otherProvider, setOtherProvider] = useState(false)
    const [portDob, setPortDob] = useState('')
    const [portAccId, setPortAccId] = useState('')
    const [portinDate, setPortinDate] = useState(null)
    const [errors, setErrors] = useState([])
    const [otherProviderName, setOtherProviderName] = useState(null);
    // const [discountApplicable,setDiscountApplicable]=useState(1)
    let discountApplicable=1
    



    const apiUrl = process.env.REACT_APP_API_URL;

    const numberSelection = (type) => {
        setExistNumber('')
        setNumberType(type);
        setSendOtp(false);
        setVerifyOtp(false);
        setProvider(false);
        setProvider('');
        setIsMultiple(false);
        setMobileNumber('')
    }

    const existHandleChange = (value) => {

        const isValid = /^0\d*$/.test(value) || value === '';
        if (isValid) {
            if (value.length < 2 || value.startsWith('04')) {
                const numericValue = value.replace(/[^0-9]/g, "");
                setMobileNumber(numericValue);
            }
        }
    };

    const handleSetOtp = (value) => {
        const numericValue = value.replace(/[^0-9]/g, "");
        setOtp(numericValue);
    };

    const handleDateChange = (date) => {
        // Check if the date is not null before formatting
        if (date) {
            const formattedDate = formatDate(date);
            setPortinDate(formattedDate);
        } else {
            // Handle the case when the date is null (clear the date)
            setPortinDate('');
        }
    };
    
      const today = new Date();

            // Calculate the date 45 days from today
            const fortyFiveDaysFromToday = new Date();
            fortyFiveDaysFromToday.setDate(fortyFiveDaysFromToday.getDate() + 45);

            // Strip the time from the date (set to midnight)
            const resetTime = (date) => {
            const newDate = new Date(date);
            newDate.setHours(0, 0, 0, 0);  // Set to midnight to remove time
            return newDate;
            };

            const minDate = resetTime(today); // Today's date at midnight
            const maxDate = resetTime(fortyFiveDaysFromToday); // 45 days from today at midnight

            // Format the date to yyyy-MM-dd (optional, if needed)
            const formatDate = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
            };

            const formattedMinDate = formatDate(minDate);
            const formattedMaxDate = formatDate(maxDate);
            console.log('date',minDate);
            console.log('day',formattedMinDate);
     
    const sendOtpHandle = async () => {
        try {
            setLoading(true);
            setOtp("")
            if(!mobileNumber){
                swal("", "Please enter a valid mobile number", 'warning');
                return ;
            }
            
            const headers = await getApiHeader();
            const response = await axios.post(`${apiUrl}activation/get/otp`, {
                session_id: commonSession,
                mobile_number: mobileNumber,
                discount_applicable:discountApplicable
            }, { headers: headers });

            if (response.status === 200) {
                setSendOtp(true);
                setOtpVerifySessionId(response.data.data.otp_session_id)
                swal("", response.data.data.message, 'success');
            }
        } catch (error) {
            if (error.response?.data?.message) {
                if(error?.response?.data?.status?.portin_discount_applicable=== 0){
                    discountApplicable=0
                }
            
                if(error.response?.data?.status?.portin_discount_applicable=== 0 ){
                    swal({
                        text: error?.response?.data?.message,
                        icon: 'warning',
                        buttons: {
                          cancel: {
                            text: "Cancel",
                            visible: true,
                            closeModal: true,
                          },
                          confirm: {
                            text: "OK",
                            closeModal: true,
                          },
                        },
                      }).then((value) => {
                        if (value) {
                            sendOtpHandle();
                        } else {
                            discountApplicable=1
                            setStep(1);
                        }
                      });
                }else{
                     swal("", error.response.data.message, 'warning')
                }

            } else {
                swal("", "Please enter a valid mobile number", 'warning');
            }
        } finally {
            setLoading(false);
        }
    };


    const verifyOtpHandle = async () => {

        if (!otp) {
            swal("", "Please enter a valid OTP", 'warning');
            return
        }
        try {
            setLoading(true);
            const headers = await getApiHeader();
            const response = await axios.post(`${apiUrl}activation/verify/otp`, {
                session_id: commonSession,
                otp_session_id: otpVerifySessionId,
                mobile_number: mobileNumber,
                otp: otp,
            }, { headers: headers });

            if (response.data.status === 200) {
                setVerifyOtp(true);
                setMobileProviders(selectedPlanData.data.providers);
                swal("", response.data.data.message, 'success');
            }
            else {
                swal("", response.data.message, 'warning');
            }
        }
        catch (error) {
            if (error.response?.data?.message) {
                swal("", error.response.data.message, 'warning');
            } else {
                swal("", "Please enter a valid OTP", 'warning');
            }
        }
        finally {
            setLoading(false);
        }
    }

    const providerHandle = (e) => {
        setProvider(e.target.value);
        if (e.target.value != 'other' && e.target.value != '') { setProviderStatus(true); }
        else { setProviderStatus(false); setServiceType(''); }
    }

    const otherproviderHandle = (e) => {
        if (e.target.value != '') { setProviderStatus(true); setOtherProviderName(e.target.value); }
        else { setOtherProvider(false); }
    }

    const serviceTypeHandle = (e) => {
        setServiceType(e.target.value);
    }


    const chooseNumberHandle = async () => {

        try {
            setLoading(true);
            const headers = await getApiHeader();

            const count = 5;

            const response = await axios.post(`${apiUrl}activation/get/number`,
                {
                    session_id: commonSession,
                    count: count
                }, { headers: headers });

            if (response.data.status === "success") {
                if (response.data.message !== 'undefined') {

                    if(response.data.numbers.length === 0){
                        swal("", "Mobile numbers not available", 'warning');
                        return;
                    }

                    const numbersData = response.data.numbers;

                    let fetchedNumbers;

                    if (Array.isArray(numbersData)) {
                        fetchedNumbers = numbersData.map(numberObj => numberObj.mobile_number);
                    } else {
                        fetchedNumbers = [numbersData.mobile_number];
                    }

                    setMultiNumbers(fetchedNumbers);
                    setIsMultiple(true);
                }
            } else {
                swal("", response.data.message, 'warning');
            }
        } catch (error) {
            if (error.response?.data?.message !== 'undefined') {
                swal("", error.response.data.message, 'warning');;
            } else {
                swal("Unexpected error", "Please try again", 'error');
            }
        }
        finally {
            setLoading(false);
        }
    };

    const otherNumber = (otherNumber) => {
        setMobileNumber(otherNumber);
    }
    const getNewNumber = async () => {
        numberSelection('new');
        setMobileNumber('');

        try {
            setLoading(true);
            const headers = await getApiHeader();
            const response = await axios.post(`${apiUrl}activation/get/number`,
                {
                    session_id: commonSession,
                    count: 1
                }, { headers: headers });
            
           
            
 
            if (response.data.status === "success") {
                 console.log('response.data',response.data);
                if (response.data.message !== 'undefined') {
                    
                    if(response.data.premium_numbers_status===1){
                         console.log('response.data',response.data);
                    handleGetpremiumNumber()
                    return;
                 }
                    const fetchedNumber = response.data.numbers.mobile_number;
                    setMobileNumber(fetchedNumber);
                    setMultiNumbers(fetchedNumber)
                }
            } else {
                swal("", response.data.message, 'warning');
            }
        } catch (error) {
            if (error.response?.data?.message !== 'undefined') {
                swal("", error.response.data.message, 'warning');
            } else {
                swal("Unexpected error", "Please try again", 'error');
            }

        } finally {
            setLoading(false);
        }
    };

    const handleCheckSubmit = async () => {

        if(!numberType){
            swal("", "Please choose an option: Get a new number or port your existing number to proceed.", 'warning');
            return;
        }

         if (mobileNumber === "" || mobileNumber === null || mobileNumber === undefined) {
            swal("", "Please provide a valid mobile number", 'warning');
            return;
        }

        if (numberType === "Keep My Number") {

            if(!sendOtp && !verifyOtp){
                swal("", "Please request OTP", 'warning');
                return;
            }

            if(!otp){
                swal("", "Please enter valid OTP.", 'warning');
                return;
            }

            if(otp && !verifyOtp){
                swal("", "Please verify OTP ", 'warning');
                return;
            }

            if(provider ===''){
                swal("", "The mobile provider field is required.", 'warning');
                return;
            }


            if(provider ==='Other'){
                if(otherProviderName ===null){
                     swal("", "The other mobile provider field is required.", 'warning');
                    return;
                }
            }


            if(serviceType ===''){
                swal("", "The type of service field is required", 'warning');
                return;
            }



            if(serviceType === 'Pre-paid'){
                if(portDob ===''){
                    swal("", "The date of birth field is required", 'warning');
                    return;
                }
            }


            if(serviceType === 'Post-paid'){
                if(portAccId ===''){
                    swal("", "The account number field is required", 'warning');
                    return;
                }
            }
        }


        const submit_data = {
            session_id: commonSession,
            number_type: numberType === "new" ? 1 : 2,
            mobile_number: mobileNumber,
            mobile_provider: provider,
            other_provider: otherProviderName,
            service_type: serviceType,
            date_of_birth: portDob,
            account_id: portAccId,
            otp_session_id: otpVerifySessionId,
            port_in_authority_date: portinDate,
            showidd:iddCheck
        };
        
        try {
            setLoading(true);
            const headers = await getApiHeader();
            const response = await axios.post(`${apiUrl}activation/update/number`,
                submit_data,
                { headers: headers });

            if (response.status === 200) {

                if(response?.data?.data?.selected_new_resource){
                    handleMobile(response.data.data.selected_new_resource);
                }

                nextStep();
            }
        } catch (error) {
            const errorData = error.response.data;
            if (typeof errorData.message === 'string') {
                swal("", errorData.message, 'warning');
            }
            if (typeof errorData.message === 'object') {
                const newErrors = {};
                Object.keys(errorData.message).forEach((field) => {
                    if (Array.isArray(errorData.message[field])) {
                        newErrors[field] = errorData.message[field][0];
                    }
                });
                setErrors(newErrors);
            }
        } finally {
            setLoading(false);
        }

    }

    const handleChange = (name,value) => {
        if (name === 'account num') {
               setPortAccId(value );
           
         }
   }

   //////////// premium number api function


   const handleGetpremiumNumber = async () => {

       console.log('inside handleGetpremiumNumber');
       
        try {
            setLoading(true)

            const API_TOKEN = process.env.REACT_APP_API_TOKEN;
            const headers = await getApiHeader();
            const response = await axios.post(`${apiUrl}activation/fetch-premium-numbers`,
                { session_id: commonSession,
                },
                { headers : headers}
            );

            if (response.status === 200) {
                setShowPremiumNumber(true)
               
                setPremiumNumber(response.data.numbers)
                 setLoading(false)
                
                if (response.data.status == "error") {
                    setShowPremiumNumber(true)
                    swal({ title: response?.data?.message, icon: "error" });
                }

            } else {
                setShowPremiumNumber(true)
                setLoading(false)
            }
        } catch (error) {
             setShowPremiumNumber(false)
            swal({ title: error.response?.data?.data?.message, icon: "error" });
            console.error("Error fetching premium numbers:", error);
            setLoading(false)
        }
    };

   const handlePremiumData =(data)=>{
     console.log('sdfsfd');
     setMobileNumber(data.mobile_number)
    //   this.setState({new_number: data.mobile_number ,reservationId:data.reservation_id}); 
     
 }
  




    useEffect(() => {
        setPaymentStatus(selectedPlanData.data.payment_status)
        setRetailerType(selectedPlanData.data.retailer_type)
    })

    return (
          <>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                {loading === true && (
                    <Loader />
                )}
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form">
                        <h6> Your Mobile Number</h6>
                        <hr />
                        <br />
                        <div className="ad-mb-result">

                            {retailerType === "ptc" && (
                                <>
                                    <div className="col-lg-6">
                                        <label className="formbold-form-label formbold-form-label-2">PTC Staff Name</label>
                                        <input type="text" name="text" placeholder="Enter PTC Staff Name" className="formbold-form-input addInput" autoComplete='off' />
                                     </div>

                                    <div className="col-lg-6">
                                        <label className="formbold-form-label formbold-form-label-2">PTC Staff Email Address</label>
                                        <input type="email" name="text" placeholder="Enter PTC Staff Email Address" className="formbold-form-input addInput" autoComplete='off' />
                                       
                                    </div>
                                </>
                            )}

                            <label className="formbold-form-label formbold-form-label-2 fwidth">Choose if you'd like to get a new number, or port your number from your current provider 
                                {/* <span style={{color : 'red'}}>*</span>< */}
                                </label>

                                <div className="col-lg-6 numbertype-picker">
                                <label
                                    htmlFor="existingNumber"
                                    className="formbold-form-label-2 number-selection pos-rel"
                                    onClick={() => {
                                        if(numberType != 'Keep My Number'){
                                        setMobileNumber('');
                                        numberSelection('Keep My Number');
                                        setPortDob("")
                                        }
                                    }}
                                >
                                    <input type="radio" name="number_type" id="existingNumber" /> Keep My Number <span className="pr-text">(Port Your Existing Number)</span>
                                </label>
                            </div>

                            <div className="col-lg-6 numbertype-picker f-pad">
                                <label htmlFor="newNumber" className="formbold-form-label-2 number-selection">
                                    <input
                                        type="radio"
                                        name="number_type"
                                        id="newNumber"
                                        onClick={() => {
                                            setMobileNumber('');
                                            getNewNumber();
                                        }}
                                    /> Get New Number
                                </label>
                            </div>

                            {numberType === 'new' && (
                                <> 
                                   {!showPremiumNumber && (
                                    <div className="new-number-section">

                                        <div className="col-lg-6">
                                            <label className="formbold-form-label formbold-form-label-2" for="mobile_number">Your Telsim Number <span className="madate_mark">*</span></label>
                                            <input type="text" name="mobile_number" id="mobile_number" className="formbold-form-input addInput readonly" value={mobileNumber} placeholder="Your Telsim Number" readOnly  autoComplete='off'/>


                                            {isMultiNumber === false && (
                                                <span className="Chooseanother" onClick={chooseNumberHandle}><i className="fa fa-hand-o-right"></i> Click here to Search / Pick a Different One?</span>
                                            )}
                                        </div>

                                        {isMultiNumber === true && (
                                            <div className="col-lg-6 choose-other-number">
                                                <label className="formbold-form-label formbold-form-label-2">Pick Number</label>
                                                <ul>
                                                    {multiNumbers.map((number, index) => (
                                                        <li key={index}>
                                                            <label
                                                                className="formbold-form-label-2"
                                                                htmlFor={number}
                                                                onClick={() => otherNumber(number)}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="anothernumber"
                                                                    id={number}
                                                                    checked={mobileNumber === number}

                                                                />
                                                                {number}
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                                <span className="Chooseanother" onClick={chooseNumberHandle}>
                                                <i className="fa fa-hand-o-right"></i> Click here to Search / Pick a Different One?
                                                </span>
                                            </div>
                                        )}
                                        
                                    </div>
                                    )}

                                    {showPremiumNumber && (
                                        <>
                                            <div className="premium-number-wrapper " >
                                                <p className="premium-number-main-info-text">
                                                    Pick Your Telsim  Number from below.
                                                </p>

                                                <div className="premium-number-category-section row">
                                                    <div className="premium-number-list col-lg-12 ">
                                                         <div className="row">
                                                        {premiumNumbers?.map(item => (
                                                            <div key={item.id} className="col-xl-4 col-lg-4 col-md-12 col-sm-6 col-12 mb-3">
                                                            <label
                                                                className="premium-number-main-item d-flex flex-row  w-100"
                                                                key={item.id}
                                                            >
                                                                <input type="radio" name="premium-number" className="premium-number-radio-button" checked={mobileNumber === item?.mobile_number} onClick={() => handlePremiumData(item)} />

                                                                <span className="premium-number-number">{item?.mobile_number}</span>
                                                                {/* <span  className={`premium-number-item ${item?.category_name.toLowerCase()}`} > {item?.category_name} </span> */}
                                                                <span className="premium-number-main-tag"> {item?.category_amount > 0 ? item.category_name : "FREE"}</span>

                                                                <span className="premium-number-main-price">
                                                                    {item.category_amount !== item?.category_offer_amount ? (
                                                                        <>
                                                                            <del>${item?.category_amount}</del> ${item?.category_offer_amount}
                                                                        </>
                                                                    ) : (
                                                                        <>${item?.category_amount > 0 ? item?.category_amount : "0.00"}</>
                                                                    )}
                                                                </span>
                                                                <span className={mobileNumber === item?.mobile_number ? "premium-number-tick" : "d-none"}> ✔</span>

                                                                {/* <span className= {this.state.new_number=== item?.mobile_number? "premium-number-tick":""}>✔</span> */}
                                                            </label>
                                                             </div> 
                                                        ))}
                                                       
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br></br>
                                        </>)
                                    }

                                </>
                            )}
                            {numberType === 'Keep My Number' && (
                                <>
                                    <div className="col-lg-6">
                                        <label className="formbold-form-label formbold-form-label-2" for="existing_number">Enter Your Existing Mobile Number <span className="madate_mark">*</span></label>

                                        {sendOtp === false && (
                                            <>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="formbold-form-input addInput"
                                                        maxLength="10"
                                                        placeholder="Enter Existing Number"
                                                        name="existing_number"
                                                        id="existing_number"
                                                        value={mobileNumber}
                                                        onChange={(e) => existHandleChange(e.target.value)}
                                                        style={{ width: '70%' }}
                                                        aria-describedby="request_port_otp"
                                                        inputMode="numeric"
                                                        autoComplete='off'
                                                    />
                                                    <div className="input-group-append spc-exitmobile-width">
                                                        <button
                                                            className="btn btn-send-otp add-mb-otp-btn"
                                                            id="request_port_otp"
                                                            type="button"
                                                            onClick={() => sendOtpHandle()}
                                                        >
                                                            Request OTP
                                                        </button>
                                                    </div>
                                                </div>

                                                
                                            </>
                                        )}
                                        {sendOtp === true && (
                                            <>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="formbold-form-input addInput readonly"
                                                        maxLength="10"
                                                        keyboardType="numeric"
                                                        placeholder="Enter Existing Number"
                                                        name="existing_number"
                                                        value={mobileNumber}
                                                        aria-describedby="request_port_otp"
                                                        readOnly
                                                        autoComplete='off'
                                                    />
                                                </div>
                                                
                                                
                                            </>
                                        )}
                                    </div>
                                    {sendOtp === true && (
                                        <>
                                            {verifyOtp == false && (
                                                <div className=" col-lg-6">
                                                    <label className="formbold-form-label formbold-form-label-2">Enter OTP <span className="madate_mark">*</span></label>
                                                    <div className="input-group">
                                                        <input type="text" className="formbold-form-input addInput" maxLength="6" placeholder="Enter OTP Number" name="otp" id="existing_number" keyboardType="numeric" autoComplete='off' value={otp} onChange={(e) => handleSetOtp(e.target.value)}
                                                            style={{ width: '70%' }} aria-describedby="request_port_otp" />
                                                        <div className="input-group-append spc-exitotp-width">
                                                            <button className="btn btn-send-otp add-mb-otp-btn" id="verify_port_otp" type="button" onClick={() => verifyOtpHandle()} > Verify OTP </button>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            )}


                                            {verifyOtp === true && (
                                                <>
                                                    <div className=" col-lg-6">
                                                        <label className="formbold-form-label formbold-form-label-2">Select Mobile Provider <span className="madate_mark">*</span></label>
                                                        <select className='formbold-form-input'
                                                            value={provider}
                                                            onChange={providerHandle}
                                                        >
                                                            <option value="">Select Service Provider</option>
                                                            {mobileProviders.length > 0 && (
                                                                mobileProviders.map(providerItem => (
                                                                    <option key={providerItem.provider_id} value={providerItem.provider}>
                                                                        {providerItem.provider}
                                                                    </option>
                                                                ))
                                                            )}
                                                        </select>
                                                        
                                                    </div>


                                                    {provider === 'Other' && (
                                                        <div className="col-lg-6">
                                                            <label className="formbold-form-label formbold-form-label-2">Enter Mobile Provider Name <span className="madate_mark">*</span></label>
                                                            <input
                                                                type="text"
                                                                name="otp"
                                                                id="password"
                                                                placeholder="Enter Mobile Provider Name"
                                                                className="formbold-form-input"
                                                                onChange={otherproviderHandle}
                                                                onKeyDown={(event) => /^[a-zA-Z ]*$/.test(event.key) || event.preventDefault()}
                                                                onPaste={(e) => e.preventDefault()}
                                                                onCopy={(e) => e.preventDefault()}
                                                                onCut={(e) => e.preventDefault()}
                                                                onDrag={(e) => e.preventDefault()}
                                                                onDrop={(e) => e.preventDefault()}
                                                                maxLength="40"
                                                                autoComplete='off'
                                                            />
                                                            {errors.mobile_provider && <span className="ad-mp-err">Please Enter Valid Mobile Provider Name</span>}
                                                        </div>
                                                    )}

                                                    {providerStatus === true && (
                                                        <>
                                                            <div className=" col-lg-6">
                                                                <label className="formbold-form-label formbold-form-label-2">Type of Service <span className="madate_mark">*</span></label>
                                                                <select className="formbold-form-input" onChange={serviceTypeHandle}>
                                                                    <option value="">Select Type of Service</option>
                                                                    <option value="Pre-paid">Pre-paid</option>
                                                                    <option value="Post-paid">Post-paid</option>
                                                                </select>
                                                                {errors.service_type && <span className="ad-mp-err">Please Enter Valid Service</span>}
                                                            </div>
                                                            {serviceType !== '' && (
                                                                <>
                                                                    {serviceType === 'Pre-paid' && (
                                                                        <div className=" col-lg-6">
                                                                            <label className="formbold-form-label formbold-form-label-2">Enter Date of Birth <span className="madate_mark">*</span></label>
                                                                           
                                                                            <DatePicker
                                                                                selected={portDob}
                                                                                onChange={(date) => {
                                                                                   
                                                                                    //const formattedDate = date ? date.toISOString().split('T')[0] : '';
                                                                                    const formattedDate = date ? date.toLocaleDateString('en-CA') : '';
                                                                                    setPortDob(formattedDate); 
                                                                                   
                                                                                }}
                                                                                dateFormat="yyyy-MM-dd"
                                                                                placeholderText="Enter Date of Birth"
                                                                                className="formbold-form-input addInput"
                                                                                wrapperClassName="date-picker-wrapper"
                                                                                id="date"
                                                                                name="date"
                                                                                autoComplete="off" 
                                                                                showYearDropdown
                                                                                showMonthDropdown
                                                                                scrollableYearDropdown
                                                                                yearDropdownItemNumber={100}
                                                                                maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))} // Set minimum age to 18

                                                                            />
                                                                            {errors.date_of_birth && <span className="ad-mp-err">{errors.date_of_birth}</span>}
                                                                        </div>
                                                                    )}
                                                                    {serviceType === 'Post-paid' && (
                                                                        <div className="col-lg-6">
                                                                            <label className="formbold-form-label formbold-form-label-2">Enter Account Number <span className="madate_mark">*</span></label>
                                                                            <input
                                                                                type="text"
                                                                                name="account num"
                                                                                id="password"
                                                                                placeholder="Enter Account Number"
                                                                                className="formbold-form-input"
                                                                                value={portAccId}
                                                                                onChange={(e) =>{ handleChange(e.target.name,e.target.value)}}
                                                                                maxLength={50}
                                                                                autoComplete='off'
                                                                            />
                                                                            {errors.account_id && <span className="ad-mp-err">Please Enter Valid Account Number</span>}
                                                                        </div>
                                                                    )}
                                                                    
                                                                    {/* <div className="col-lg-6">
                                                                        <label className="formbold-form-label formbold-form-label-2">
                                                                        Portin Authority Date
                                                                        </label>
                                                                        <p>If you wish to port in your number on a future date, please enter the date here.</p>

                                                                        <DatePicker
                                                                            selected={portinDate}
                                                                            onChange={handleDateChange}
                                                                            dateFormat="yyyy-MM-dd" 
                                                                            minDate={minDate} 
                                                                            maxDate={maxDate} 
                                                                            className="formbold-form-input addInput"
                                                                            wrapperClassName="date-picker-wrapper"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            scrollableYearDropdown
                                                                            yearDropdownItemNumber={100}
                                                                            autoComplete="off" 
                                                                            />
                                                                                                                                            
                                                                      
                                                                        {portinDate === null && <span className="ad-mp-err"></span>}
                                                                    </div> */}


                                                                </>
                                                            )}

                                                        </>
                                                    )}

                                                </>
                                            )}
                                        </>
                                    )}

                                </>
                            )}

                            {/* <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br /> */}
                            <div className="button-container add-mb-button-container">
                                <button className="button btn btn-danger" onClick={prevStep}>
                                    Back
                                </button>

                                <button className="button btn btn-danger ad-mb-button-next" onClick={handleCheckSubmit}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </>
    )
}

export default YourMobileNumber